<template>
    <modal name="blank-modal"
           :width="0"
           :height="0"
           :min-width="0"
           :min-height="0"
           :pivotX="0"
           :pivotY="0.3"
           :delay="100"
           @before-close="beforeClose"
    ></modal>

</template>

<script>
    // 이 모달의 존재이유 : 햄버거 메뉴에서 검정 오퍼씨티 영역 클릭하면 사라지게 하려궁
    export default {
        name: 'BlankModal',
        components: {},
        props: [''],
        data() {
            return {
            }
        },
        methods: {
            modalClose: function (event) {
                this.$modal.hide('blank-modal');
                event?.stopPropagation();
                event?.preventDefault();
            },
            beforeClose () {
                this.$store.dispatch('setHamburgerVisible', false);
            }
        },
    }
</script>
